import Navbar from '../utils/navbar';
import Foot from '../utils/foot';

export default function Root ({content}) {
    return (
        <>
        <Navbar/>
        <div className='content'>
            {content}
        </div>
        <Foot/>
        </>
    )
}